import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { NgModel, ControlValueAccessor } from '@angular/forms';


@Component( {
    selector: 'app-pagination',
    template: `
<ul class="pagination" >
  <li><a (click)="toFirstPage()">First</a></li>
  <li> <a (click)="toPreviousPage()" aria-label="Previous"> <span aria-hidden="true">&laquo;</span> </a> </li>
  <li *ngFor="let pageNo of pageList" [ngClass]="{'active':seletedPage === pageNo}">
      <a (click)="setCurrentPage(pageNo)">{{pageNo}}</a>
  </li>                
  <li> <a (click)="toNextPage()" aria-label="Next"> <span aria-hidden="true">&raquo;</span> </a> </li>
  <li><a (click)="toLastPage()">Last&nbsp;&nbsp;<span class="badge active">{{lastPage}}</span></a></li>
</ul>


`
})
export class PaginationDirective implements OnInit, OnChanges {
    @Input() totalItems: number;
    @Input() pageSize: number;
    @Input() maxButtons: number;
    @Input() currentPage: number;

    @Input() previousText: string;
    @Input() nextText: string;
    @Input() firstText: string;
    @Input() lastText: string;

    @Output() pageChanged = new EventEmitter();

    pageList: Array<number> = [];
    private onChange: Function;
    private onTouched: Function;
    public seletedPage: number;
    private nextItem: number;
    private previousItem: number;
    public lastPage: number;

    ngOnInit() {
    }

    ngOnChanges( changes: SimpleChanges ) {
        if ( changes['totalItems'] ) {
            this.calculatePages();
            this.doPaging();
        }
    }

    calculatePages() {
        let wholePages =  Math.floor(this.totalItems / this.pageSize);
        let remaining = this.totalItems % this.pageSize;
        this.lastPage = wholePages + (remaining > 0 ? 1 : 0);
    }

    doPaging() {
        this.pageList = [];
        if ( this.totalItems === 0 ) {
            return;
        }
        let i: number, count: number;
        this.seletedPage = this.currentPage;
        let maxButton = Math.min( this.lastPage, this.maxButtons );
        let start = this.currentPage - Math.floor( maxButton / 2 );
        if (start > (this.lastPage - maxButton)) {
            start = this.lastPage - maxButton + 1;
        }
        if (start < 1) {
            start = 1;
        }

        for ( i = start, count = 0; i <= this.lastPage && count < this.maxButtons; i++ , count++ ) {
            this.pageList.push( i );
        }
    }

    changeToPage( newPage: number ) {
        if (newPage > this.lastPage) {
            newPage = this.lastPage;
        }

        if (newPage < 1) {
            newPage = 1;
        }

        if ( this.currentPage === newPage ) {
            return;
        }

        this.pageChanged.emit( {
            oldpage: this.currentPage,
            newpage: newPage
        });

        this.currentPage = newPage;
        this.doPaging();
    }

    setCurrentPage( pageNo: number ) {
        this.changeToPage( pageNo );
    }

    toFirstPage() {
        this.changeToPage( 1 );
    }

    toLastPage() {
        this.changeToPage( this.lastPage );
    }

    toNextPage() {
        this.changeToPage( this.currentPage + 1 );
    }

    toPreviousPage() {
        this.changeToPage( this.currentPage - 1 );
    }
}


// WEBPACK FOOTER //
// ./src/app/components/Grid/pagination.directive.ts